import angular from "angular"

import { isIdentityAuthMode, refreshAccessToken } from "@/identity-token-refresh.js"

angular.module("appModule").service("tokenRefreshService", function() {
  return {
    isIdentityAuthMode: isIdentityAuthMode,
    refreshAccessToken: refreshAccessToken
  }
})
